import { Component } from '@angular/core';
import { CommonSharedModule } from '../common/shared.module';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  standalone: true,
  imports: [CommonSharedModule]
})
export class ErrorComponent {}
